// App.js
import React from 'react';
import './App.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import { Routes, Route, Navigate } from 'react-router-dom'; // Import Navigate for redirect
import PM from './components/PM/pm';
import PMCampaign from './components/PMCampaign/pmCampaign';
import Landing from './section/landing'
import NotFoundPage from './components/404';
import LungLanding from './section/LungRenew';
import U1 from './section/LungRenew/section/u1';
import OrderConfirmation from './section/LungRenew/section/order-confirmation';
import LungRenewPM from './section/LungRenew/section/pm';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/pm" element={<PM />} />
        <Route path='/lung-renew/u1' element={<U1 />} />
        <Route path='/lung-renew/pm' element={<LungRenewPM />} />
        <Route path='/lung-renew/thankyou' element={<OrderConfirmation />} />
        <Route path="/pm-campaign" element={<PMCampaign />} />
        <Route path="/lung-renew" element={<LungLanding />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
}

export default App;
